import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Paper, Box, Button } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { getCarreras } from "../../../services/hipodromo";
import { ResponseProximasCarrerasIds } from "../../../interfaces/priximas_carreras.interface";

const RaceSelector: React.FC = () => {
    const [allRaces, setAllRaces] = useState<ResponseProximasCarrerasIds[]>([]);
    const { hipodromoId, id, proCarIdHipodromo } = useParams<{ hipodromoId: string, id?: string, proCarIdHipodromo?: string }>();
    const navigate = useNavigate();
    const location = useLocation();

    // Determine the current race ID from params (could be 'id' or 'proCarIdHipodromo' depending on route)
    const currentRaceId = Number(id || proCarIdHipodromo);

    useEffect(() => {
        const fetchRaces = async () => {
            try {
                const hId = hipodromoId ? Number(hipodromoId) : 1;
                const races = await getCarreras(hId);
                setAllRaces(races);
            } catch (error) {
                console.error("Error fetching races list:", error);
            }
        };
        fetchRaces();
    }, [hipodromoId]);

    const currentDayRaces = allRaces.find(day => day.ids.includes(currentRaceId));

    if (!currentDayRaces) return null;

    // Default hipodromoId to 1 if not present (some routes might lack it)
    const activeHipodromoId = hipodromoId || '1';

    const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
        const currentPath = location.pathname;
        let newPath = '';

        if (currentPath.includes('/handicap')) {
            newPath = `/hipodromo/${activeHipodromoId}/carrera/${newValue}/handicap`;
        } else if (currentPath.includes('/predic-handicap')) {
            newPath = `/hipodromo/${activeHipodromoId}/carrera/${newValue}/predic-handicap`;
        } else if (currentPath.includes('/agent')) {
            newPath = `/hipodromo/${activeHipodromoId}/carrera/${newValue}/agent`;
        } else if (currentPath.includes('/simulacion')) {
            newPath = `/hipodromo/${activeHipodromoId}/carrera/${newValue}/simulacion`;
        } else {
            newPath = `/hipodromo/${activeHipodromoId}/carrera/${newValue}`;
        }

        navigate(newPath);
    };

    return (
        <Paper elevation={1} sx={{ bgcolor: 'background.paper', mb: 1, mx: {xs: 0, md: 2}, mt: {xs: 0, md: 2}, display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
            <Tabs
                value={currentRaceId}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="scrollable race tabs"
                onChange={handleTabChange}
                sx={{ flexGrow: 1, maxWidth: '100%' }}
            >
                {currentDayRaces.ids.map((raceId, index) => (
                    <Tab key={raceId} value={raceId} label={`C. ${index + 1}`} />
                ))}
            </Tabs>
            
            {currentDayRaces.is_limited && (
                 <Box sx={{ p: 1 }}>
                     <Button 
                        variant="outlined" 
                        color="warning" 
                        size="small"
                        startIcon={<LockIcon />}
                        onClick={() => navigate('/subscription')}
                        sx={{ whiteSpace: 'nowrap', textTransform: 'none', fontSize: '0.8rem' }}
                     >
                        {currentDayRaces.total_available ? `+${currentDayRaces.total_available - currentDayRaces.ids.length} Carreras` : 'Ver más'}
                     </Button>
                </Box>
            )}
        </Paper>
    );
};

export default RaceSelector;
